import Community from "@components/Collection/artist/Community";

export default Community;
